export type StrategyExitDiscoveryStatus =
    | 'pending'
    | 'partial_running'
    | 'partial_complete'
    | 'reduce_running'
    | 'evidence_ready'
    | 'deleting'
    | 'failed'
    | 'cancelled'
    | null;

export interface ObjectiveOutcomeSetOption {
    id: number;
    exitCandidateId: number | null;
    producerKind: string;
    discoveryStatus: StrategyExitDiscoveryStatus;
}

/**
 * Prefer evidence that scorecard authoring can consume immediately. If no matching set is ready yet, keep
 * the experiment-owned objective visible so its normal preparation progress is shown instead of silently
 * switching to an unrelated producer's set.
 */
export const selectObjectiveIntentOutcomeSet = (
    outcomeSets: ObjectiveOutcomeSetOption[],
    intentExitCandidateId: number
): ObjectiveOutcomeSetOption | null => {
    const matchingSets = outcomeSets.filter((set) => set.exitCandidateId === intentExitCandidateId);

    return (
        matchingSets.find((set) => set.discoveryStatus === 'evidence_ready') ??
        matchingSets.find((set) => set.producerKind === 'experiment_objective') ??
        matchingSets[0] ??
        null
    );
};

export const isStrategyExitDiscoveryActive = (status: StrategyExitDiscoveryStatus): boolean =>
    status === 'pending' ||
    status === 'partial_running' ||
    status === 'partial_complete' ||
    status === 'reduce_running' ||
    status === 'deleting';
